import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import routes from "@/config/routes.ts";
import DiplomaRequestMobileLayout from "@/layouts/DiplomaRequestMobileLayout.tsx";
import dayjs from "dayjs";
import useDiplomaRequest from "@/utils/hooks/useDiplomaRequest.ts";
import { CalenderItem } from "@/types";
import HourPicker from "@edusogno/composites/hours";
import { useTranslation } from "react-i18next";
import Button from "@edusogno/primitives/button";
import { ScrollArea } from "@edusogno/primitives/scroll-area";

export default function DiplomaRequestSelectHour() {
  const navigate = useNavigate();
  const { hour, setState } = useDiplomaRequest();
  const location = useLocation();
  const stateData = location.state as CalenderItem[] | undefined;
  const { t } = useTranslation();

  useEffect(() => {
    if (!stateData) {
      navigate(routes.diploma_request_select_date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateData]);

  return (
    <DiplomaRequestMobileLayout>
      {stateData && (
        <>
          {/*<div className={"h-full w-full flex-grow gap-x-4"}>*/}
          <ScrollArea className={"h-[calc(100%_-_40px)] "}>
            <HourPicker
              className={"[&_button]:flex-[1_1_129px] [&_button]:h-[35px]"}
              value={hour as string}
              hours={stateData?.map((cal) => dayjs(cal.date).format("HH:mm"))}
              openHours={stateData?.map((cal) =>
                dayjs(cal.date).format("HH:mm"),
              )}
              onValueChange={(e) => {
                setState("hour", e as string);
                // find the selected calendar
                const selectedCalendar = stateData?.find(
                  (cal) => dayjs(cal.date).format("HH:mm") === e,
                );
                if (selectedCalendar) {
                  setState("calendar", selectedCalendar);
                }
              }}
            />
          </ScrollArea>
          {/*</div>*/}
          <div
            className={
              "flex mt-auto pt-2 w-full justify-between flex-1 flex-grow gap-x-2"
            }
          >
            <Button
              size={"md"}
              variant={"contained"}
              onClick={() => navigate(-1)}
            >
              {t("btns.back")}
            </Button>
            <Button
              size={"md"}
              color={"green"}
              variant={"contained"}
              disabled={!hour}
              onClick={() =>
                navigate(routes.diploma_request_confirm, { replace: true })
              }
            >
              {t("btns.confirm")}
            </Button>
          </div>
        </>
      )}
    </DiplomaRequestMobileLayout>
  );
}
